import { BlockWrapper, defineBlock, smartProps, useEditor } from '@smartfire/glue-ui/block';
import { EditableText, EditableImg } from '@smartfire/components';
import clsx from 'clsx';
import style from './style.module.scss';

function HowItWorksStep() {
    const { isEditing } = useEditor();
    return (
        <BlockWrapper.Li className={clsx(style.block, 'swiper-slide', isEditing && style.admin)}>
            <EditableImg smartProp="image" className={style.image} />
            <EditableText smartProp="step" className={style.step} tagName="p" placeholder="ÉTAPE N" />
            <EditableText smartProp="title" className={style.title} tagName="h4" placeholder="Titre" />
            <EditableText smartProp="description" className={style.description} tagName="p" placeholder="Description" />
        </BlockWrapper.Li>
    );
}

export default defineBlock({
    Block: HowItWorksStep,
    smartProps: {
        image: smartProps.image,
        step: smartProps.string.withDefault(''),
        title: smartProps.string.withDefault(''),
        description: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Comment ça marche - Étape',
        parent: ['smartfire/how-it-works'],
    },
});
